import { Config } from './types';

export const prod: Config = {
  CONSENT_MANAGER_SCRIPT_URL:
    'https://d39xvdj9d5ntm1.cloudfront.net/common/static/consent-manager.js',
  RWA_CLIENT_ID: 'RingtercomCompatibilityChecker',
  RWA_AWS_REGION: 'us-east-1',
  RWA_EVENT_STREAM_ENDPOINT: 'https://eventstream.ring.com/anon',
  RWA_GROUP: 'client.device',
  RWA_SUBGROUP: 'ring.site.webapp',
};
